import React from "react";
import { useState,useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import Editor from 'react-simple-wysiwyg';
import { Helmet } from "react-helmet";
import './classes/AddNews.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { configData } from "../config";
import Loading from './Loading';

const AddTestimonialPage = () => {

    const initialFormData = {
        title:'',
        user_id: '',
        field_author_title: '',
        summary: '',
        body: '',        
        field_meta_title:'',
        field_meta_keywords:'',
        field_meta_description:'',
        placements: [{ placement_page: '', placement_sort_order: '1' }],
    };

    const [formData,setFormData] =useState(initialFormData);
    const [isLoading, setIsLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const [showSummary, setShowSummary] = useState(false);
    const [editorMode, setEditorMode] = useState({
        body: true,
    });
    const [PreviewFields, setPreviewFields] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [userLoggedInRoles,setUserLoggedInRoles] = useState([]);
    const [searchValue, setSearchValue] = useState('');    
    const [options, setOptions] = useState([]);        
    const [selectedUser, setSelectedUser] = useState(null);
    const [pages, setPages] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const domainName = window.location.hostname;
    const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
    const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
    const location  = useLocation();
    const drupal_uid = localStorage.getItem('drupal_uid');  
    var loggedin_domain = drupal_domain_url;
    if(localStorage.getItem('loggedin_domain')) {
    loggedin_domain = localStorage.getItem('loggedin_domain');
    } 
    var {uid} = useParams();
    var {username} = useParams();
    if(location.state) {
    uid = location.state;
    }
    const {tab} = useParams();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;


    useEffect(() => {
        Promise.all([
            getplacementlist(),
            getuserloggedinroles(),
        ]).then(() => {
            setIsLoading(false);
        })
    }, []);
    useEffect(() => {
        
    
    const fetchData = async () => {
        if (searchValue.trim() === '') {
        setOptions([]); 
        return;
        }
        try {
       const response = await fetch(app_url+'testimonialpages/getaccountlist?query='+searchValue);
        const data = await response.json();
        setOptions(data.data.result); 
        } catch (error) {
        console.error('Error fetching data:', error);
        }
    };
    
    const handler = setTimeout(() => {
        fetchData();
    }, 500); 

    return () => {
        clearTimeout(handler);
    };
    }, [searchValue]);

    
    const getOptionLabel = (option) => {
    if (typeof option === 'string') return option;
    return option?.name || option?.label || '';
    };

    const renderOption = (props, option) => (
    <li {...props} key={option.id || option.name}>
        {option.name || option.label}
    </li>
    );
        
    const onChange = (event, newValue) => {
        setSelectedUser(newValue);
        setFormData((prev) => ({
            ...prev,
            user_id: newValue ? (newValue.id || newValue.user_id || '') : '', 
        }));
        if (newValue) {
            setSearchValue(newValue.name || newValue.label || '');
        } else {
            setSearchValue('');
        }
    };   
   
     async function getplacementlist() {
    
         try {
            const response = await fetch(
                app_url+'node/getnodepages',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setPages(responsedata.data.result);
               
            } 
        } catch (err) {
            
        }
        
    }

    async function getuserloggedinroles() {

        try {
        setIsLoading(true);
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",

                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
            
            setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
    }finally {
            setIsLoading(false); 
        }
    
    }   
    const handleAddPlacement = () => {
        setFormData((prev) => ({
        ...prev,
        placements: [...prev.placements, { page: '', order: '1' }],
        }));
    };

    const handleDeletePlacement = (index) => {
        const updated = formData.placements.filter((_, i) => i !== index);
        setFormData((prev) => ({ ...prev, placements: updated }));
    };

    const handlePlacementChange = (index, field, value) => {
        const updated = [...formData.placements];
        updated[index][field] = value;
        setFormData((prev) => ({ ...prev, placements: updated }));
    };

    const handlePreviewClick = () => {
        const {
        title,
        summary,
        body,
        field_author_title,
        field_meta_title,
        field_meta_keywords,
        field_meta_description,
        } = formData;

        const newErrors = {};
        if (!title.trim()) {
            newErrors.title = "Display Name field is required.";
            window.scrollTo(0, 0);
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setPreviewFields(false);
            return;
        }

        const cleanedSummary = cleanHtmlOutput(summary);
        const cleanedBody = cleanHtmlOutput(body);

        const hasSummary = cleanedSummary && cleanedSummary.trim() !== '';
        let trimmedHtml = '';

        if (hasSummary) {
            trimmedHtml = cleanedSummary;
        } else if (cleanedBody.includes('<!--break-->')) {
            trimmedHtml = cleanedBody.split('<!--break-->')[0];
        } else {
            const tmp = document.createElement('div');
            tmp.innerHTML = cleanedBody;
            trimmedHtml = '';
        }

        setPreviewData({
            title,
            summary: hasSummary ? cleanedSummary : '',
            trimmed: trimmedHtml,
            body: cleanedBody,
            field_author_title,   
            field_meta_title,
            field_meta_keywords,
            field_meta_description,
        });

        setErrors({});
        setPreviewFields(true);
        window.scrollTo(0, 0);
    };

    const cleanHtmlOutput = (html) => {
        if (!html || typeof html !== 'string') return '';

        let cleaned = html;

        cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');

        cleaned = cleaned.replace(/<br\s*\/?>/gi, '');

        const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();

        return textOnly.length === 0 ? '' : cleaned.trim();
    };

     const toggleEditor = (field) => {
        setEditorMode(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const onEditorChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;

        setFormData(prev => {
        if (type === "checkbox" && Array.isArray(prev[name])) {
            return {
            ...prev,
            [name]: checked
                ? [...prev[name], value]
                : prev[name].filter(v => v !== value),
            };
        }

        return {
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        };
        });
    };
    
    const validateForm = () => {
        const newErrors = {};
        if (!formData.title.trim()) {
        newErrors.title = "Display Name field is required.";
        window.scrollTo(0, 0);
        }
        return newErrors;
    };

    const inputStyle = {
        title: {
        border: errors.title ? '2px solid red' : '1px solid #777'
        }
    };


    const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    setErrors(validationErrors);
    setPreviewFields(false);
    setPreviewFields(false);
    window.scrollTo(0, 0);
    if (Object.keys(validationErrors).length > 0) return;    
    setFormData(prevState => ({
        ...prevState,
        button_name: "Saving..."
    }));
    setDisabled(true);
    const cleanedSummary = cleanHtmlOutput(formData.summary);
    const cleanedBody = cleanHtmlOutput(formData.body);    
    const postData = new FormData();
    const updatedFormData = {
        ...formData,
        summary: cleanedSummary,
        body: cleanedBody,       
    };
    console.log("Submitted data:", updatedFormData);
    postData.append('formData', JSON.stringify(updatedFormData));
    try {
        const response = await fetch(app_url + 'testimonialpages/addnewtestimonial', { 
            method: 'POST',
            body: postData,
        });
        const data = await response.json();
        if (data.data.msg === "Success") {  
            setFormData(initialFormData);             
            setDisabled(false);            
            // Redirect smoothly to view details
            navigate('/manage-testimonials', { state: { message: data.data.result } });
        } else {
            setDisabled(false);
            setFormData(prevState => ({
                ...prevState,
                button_name: "Save"
            }));
        }
    } catch (error) {
        console.error("Error during form submission: ", error);
        setDisabled(false);
        setFormData(prevState => ({
            ...prevState,
            button_name: "Save"
        }));
    }
};

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet>
                        <title>
                            Create Testimonial | SMWW 
                        </title>
                    </Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <h1>Create Testimonial</h1>
                        <div className="agency-news-create-preview">
                            {PreviewFields && (
                            <>
                                <div
                                    className="messages status"
                                    style={{
                                        background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,
                                        backgroundPosition: '10px 10px',
                                    }}
                                >
                                    The trimmed version of your post shows what your post looks like when promoted
                                    to the main page or when exported for syndication.
                                    <span>
                                        You can insert the delimiter &lt;!--break--&gt; (without the quotes) to
                                        fine-tune where your post gets split.
                                    </span>
                                </div>

                                <div className="preview-container">
                                    {/* Trimmed version */}
                                    <div className="preview-trimmed">
                                        <h4 className="preview-heading">
                                            Preview trimmed version
                                        </h4>

                                        <div className="email-teaser">
                                            <h2 className="email-title">
                                                <span style={{color: "#2C99D2"}}>{previewData?.title}</span>
                                            </h2>

                                            {(previewData.summary?.trim() || previewData.body?.includes('<!--break-->') || previewData.trimmed) && (
                                                <div
                                                    className="preview-body-content"
                                                    dangerouslySetInnerHTML={{ __html: previewData.trimmed }}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    {/* Full version */}
                                    <div className="preview-full">
                                        <h4 className="preview-heading">
                                            Preview full version
                                        </h4>
                                        <div className="email-teaser">
                                            <h2 className="email-title">
                                                {/* <strong>Body:</strong> */}
                                            </h2>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                __html: previewData.body || '',
                                                }}
                                            />
                                            <div className="email-meta">
                                                {previewData.field_author_title && (
                                                <p><strong>Title:</strong> {previewData.field_author_title}</p>)}
                                                {previewData.field_meta_title && (
                                                <p><strong>Meta Title:</strong> {previewData.field_meta_title}</p>)}
                                                {previewData.field_meta_keywords && (
                                                <p><strong>Meta Keywords:</strong> {previewData.field_meta_keywords}</p>)}
                                                {previewData.field_meta_description && (
                                                <p><strong>Meta Description:</strong> {previewData.field_meta_description}</p>)}                                                
                                           
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            )}
                        </div>
                        <div className="agency-news-create-container">
                            {Object.values(errors).some(msg => !!msg) && (
                                <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                >
                                    <ul>
                                    {Object.values(errors)
                                        .filter(msg => !!msg)
                                        .map((msg, index) => (
                                        <li key={index}>{msg}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>
                                <div>
                                    <div className="form-item">
                                        <label htmlFor="edit-title">
                                        Display Name  
                                        <span className="form-required" title="This field is required.*">*</span>
                                        </label>
                                        <input
                                        type="text" 
                                        id="edit-title" 
                                        name="title" 
                                        maxLength={255}
                                        onChange={handleChange} 
                                        value={formData.title}
                                        style={inputStyle.title}
                                        />
                                    </div>
                                    <div className="form-item edit-agent-block">
                                        <label>Select a user (Autocomplete, search by First Name and/or Last Name) </label>
                                    <Autocomplete
                                        id="add_athlete_name"
                                        disablePortal
                                        options={options}
                                        size="small"
                                        sx={{ 
                                            width: "98%", 
                                            backgroundColor:"#fff",
                                            border: "1px solid rgb(119, 119, 119)",
                                            display: "inline-block"
                                        }}
                                        renderOption={renderOption}
                                        getOptionLabel={getOptionLabel}
                                        onChange={onChange}
                                        value={selectedUser}
                                        inputValue={searchValue}
                                        onInputChange={(event, newInputValue) => setSearchValue(newInputValue)}
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                    />
                                    </div>
                                    <div className="form-item -field-meta-title">
                                        <label htmlFor="meta_title">Meta Title</label>
                                        <input className='' type="text" id="meta_title" name="field_meta_title" value={formData.field_meta_title} 
                                        onChange={handleChange}  
                                        /> 
                                    </div>
                                    <div className="form-item field-meta-keywords">
                                        <label htmlFor="meta_keywords">Meta Keywords</label>
                                        <input className='' type="text" id="meta_keywords" name="field_meta_keywords" value={formData.field_meta_keywords} 
                                            onChange={handleChange}
                                        /> 
                                    </div>
                                            <div className="form-item  fieldmeta-description">
                                        <label>Meta Description</label>
                                        <textarea
                                            name="field_meta_description"
                                            value={formData.field_meta_description}
                                            onChange={handleChange}
                                            
                                        />
                                <div className="grippie" style={{
                                    background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                }}>   
                                </div>
                            </div>
                                   
                                    
                                {/* Author Name */}
                                <div className="form-item">
                                <label htmlFor="field_author_name">Title</label>
                                <input
                                    type="text"
                                    id="field_author_name"
                                    name="field_author_title"
                                    className="text-full form-text"
                                    value={formData.field_author_title}
                                    onChange={handleChange}
                                    maxLength={255}
                                />
                                </div>                                      
                                    
                                <div>
                                    <div>
                                    {showSummary && (
                                        <div className="form-item">
                                            <label htmlFor="create_summary">
                                                Summary <span>(<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                                            </label>
                                            <>
                                                <Editor 
                                                value={formData.summary} 
                                                onChange={(e) => {
                                                    const newValue = e?.target?.value || '';
                                                    setFormData((prev) => ({ ...prev, summary: newValue }));
                                                }}
                                                />
                                            </>
                                            <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                        </div>
                                    )}
                                
                                    <div className="form-item">
                                        <label htmlFor="create_body">
                                            Body
                                            {!showSummary && (
                                                <span>
                                                    (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                                                        Edit Summary
                                                    </a>)
                                                </span>
                                            )}
                                        </label>
                                        <>
                                            {editorMode.body ? (
                                        <Editor
                                            containerProps={{ style: { resize: 'vertical', height:'300px' } }}  
                                            value={formData.body} 
                                            onChange={e => onEditorChange('body', e.target.value)} 
                                        />
                                    ) : (
                                        <>
                                            <textarea 
                                                className="new-conference-form-textarea" 
                                                name="body"
                                                value={formData.body} 
                                                onChange={e => onEditorChange('body', e.target.value)} 
                                                rows={20} 
                                            />
                                            <div
                                                className="grippie" 
                                                style={{background: `#eee url(/images/grippie.png) no-repeat center 2px`,}}
                                            >
                                            </div>
                                        </>
                                    )}
                                    <a onClick={() => toggleEditor('body')}>Switch to {editorMode.body ? 'Plain' : 'Rich'} Editor</a>
                                        </>
                                    </div>
                                </div>
                                <fieldset 
                                    className="form-wrapper" 
                                    style={{
                                        border: "1px solid #ccc", 
                                        padding: "15px 20px", 
                                        marginBottom: "15px",
                                        fontFamily: "sans-serif"
                                    }}
                                >

                            <div className="editprofile-fieldset-wrapper">
                                <label>PLACEMENTS</label>
                                <table 
                                    style={{
                                        width: "100%",
                                        borderCollapse: "collapse",
                                        backgroundColor: "white",
                                        border: "1px solid #ccc",
                                        fontSize: "11px"
                                    }} 
                                    className="placements-table"
                                >
                                    <thead>
                                        <tr style={{ backgroundColor: "#e1e2dc", borderBottom: "1px solid #ccc" }}>
                                            <th style={{ 
                                                width: '70%', 
                                                padding: '6px 10px', 
                                                textAlign: 'left', 
                                                fontWeight: 'bold', 
                                                color: '#333',
                                                textTransform: 'uppercase',
                                                borderRight: '1px solid #ccc'
                                            }}>
                                                Page
                                            </th>
                                            <th style={{ 
                                                width: '15%', 
                                                padding: '6px 10px', 
                                                textAlign: 'left', 
                                                fontWeight: 'bold', 
                                                color: '#333',
                                                textTransform: 'uppercase',
                                                borderRight: '1px solid #ccc'
                                            }}>
                                                Sort Order
                                            </th>
                                            <th style={{ 
                                                width: '15%', 
                                                padding: '6px 10px', 
                                                textAlign: 'center', 
                                                fontWeight: 'bold', 
                                                color: '#333',
                                                textTransform: 'uppercase'
                                            }}>
                                                Delete
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                        {formData.placements.map((placement, index) => (
                            <tr key={index} style={{ borderBottom: index < formData.placements.length - 1 ? "1px solid #ccc" : "none" }}>
                                {/* Page Select Column */}
                                <td style={{ padding: '10px', borderRight: '1px solid #ccc' }}>
                                    <select
                                        className="placement-select"
                                        name={`placement_page_${index}`}
                                        value={placement.page}
                                        onChange={(e) =>
                                            handlePlacementChange(index, 'page', e.target.value)
                                        }
                                        style={{
                                            width: "100%",
                                            padding: "4px",
                                            border: "1px solid #ccc",
                                            borderRadius: "2px",
                                            fontSize: "12px",
                                            boxSizing: "border-box"
                                        }}
                                    >
                                        <option value="">Select a page</option>
                                        {pages.length > 0 && (
                                            <>
                                                {pages.map((item) => (
                                                    <option key={item['id']} value={item['id']}>
                                                        {item['title']}
                                                    </option>
                                                ))}
                                            </>
                                        )}
                                    </select>
                                </td>

                                    {/* Sort Order Select Column */}
                                    <td style={{ padding: '10px', textAlign: 'center', borderRight: '1px solid #ccc' }}>
                                        <select
                                            name={`placement_sort_order_${index}`}
                                            className="adduser-form-select"
                                            value={placement.order}
                                            onChange={(e) =>
                                                handlePlacementChange(index, 'order', e.target.value)
                                            }
                                            style={{
                                                width: "100%",
                                                maxWidth: "60px",
                                                padding: "4px",
                                                border: "1px solid #ccc",
                                                borderRadius: "2px",
                                                fontSize: "12px"
                                            }}
                                        >
                                            {[...Array(50)].map((_, i) => (
                                                <option key={i + 1} value={i + 1}>
                                                    {i + 1}
                                                </option>
                                            ))}
                                        </select>
                                    </td>

                                    {/* Delete Button Column */}
                                    <td style={{ padding: '10px', textAlign: 'center' }}>
                                        <button
                                            type="button"
                                            className='quick-links-reg-button form-submit'
                                            onClick={() => handleDeletePlacement(index)}
                                            
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                                {/* Add Placement Link */}
                                <div style={{ marginTop: "12px" }}>
                                    <a
                                        className="add-placement-link"
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleAddPlacement();
                                        }}
                                        style={{
                                            color: "#0071B8",
                                            textDecoration: "none",
                                            fontWeight: "bold",
                                            fontSize: "12px"
                                        }}
                                        onMouseOver={(e) => e.currentTarget.style.textDecoration = "underline"}
                                        onMouseOut={(e) => e.currentTarget.style.textDecoration = "none"}
                                    >
                                        + Add
                                    </a>
                                </div>
                            </div>
                        </fieldset>
                        </div>
                               
                               
                        <div className="form-actions form-wrapper" id="create-actions">
                            <input type="submit" id="create-submit" name="" value="Save" className="form-submit" />&nbsp;&nbsp;
                            <input 
                                type="button" 
                                id="edit-preview"  
                                value="Preview" 
                                className="form-submit" 
                                onClick={()=> {
                                handlePreviewClick();
                                }}
                            />
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div className="right">
            <SalespersonSidebar/>
        </div>
        </div>
            )}
        </>
    );
};
export default AddTestimonialPage;